const { roundNumber } = require('../utils')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {number} amount
 * @param {number} duration
 * @param {number} interest
 * @param {number} monthlyFee
 * @returns {number}
 */
function calculateMonthlyCost ({ amount = 0, duration = 0, interest = 0, monthlyFee = 0 } = {}) {
  if (duration <= 0) return 0

  const monthlyCost = amount * (interest / 100) / 12 / (1 - Math.pow(1 + (interest / 100) / 12, (duration * -1)))
  return roundNumber(monthlyCost + monthlyFee, 4)
}

module.exports = { calculateMonthlyCost }
